<ng-container *ngIf="this.site != undefined">
    <app-detailsBase *ngIf="!this.isAlternativeDetails || this.type=='special'"></app-detailsBase>
    <app-detailsAlter *ngIf="this.isAlternativeDetails && this.type!='special'"></app-detailsAlter>
</ng-container>